import {Chip, Grid, Typography} from "@mui/material";
import * as React from "react";
import IconButton from "@mui/material/IconButton";
import SettingsIcon from '@mui/icons-material/Settings';
import {HelpOutline} from "@mui/icons-material";
import {FermentationTimingSettingsDialog} from "./FermentationTimingSettingsDialog";
import {FermentationTimingSettingsControl} from "./FermentationTimingSettingsControl(props)";
import {useState} from "react";

function FermentationTimingControl(props) {
  const {headingLabel, showSettings, fermPctValue, fermPctName, fermPctLabel, fermPctValueArr, fermTempValue, fermTempName, fermTempLabel,
    fermStateLabel, fermTempValueArr, onChange, timeDisplayValue, timeDisplayWarning, onHelpClick} = props
  const [openSettingsDialog, setOpenSettingsDialog] = useState(false)

  function renderHeading() {
    return `${headingLabel} ${fermPctValue}% @${fermTempValue}°F:`
  }

  function renderWarning() {
    const warningMessage = timeDisplayWarning()
    if (warningMessage !== undefined) {
      return (
        <Typography sx={{fontSize: 10, marginTop: -0.5, fontStyle: 'italic'}} gutterBottom>
          {warningMessage}
        </Typography>
      )
    }
    return null
  }

  return (
    <div>
      <Grid item>
        <Typography variant={'subtitle2'} gutterBottom>{renderHeading()}
          <Chip sx={{marginLeft: 1}} label={timeDisplayValue()} size={'small'} color={'secondary'} />
          <IconButton disabled={false} color={'primary'}
                      onClick={onHelpClick}><HelpOutline fontSize={'small'}/></IconButton>
          {!showSettings ? (
            <IconButton disabled={false} color={'primary'} sx={{marginLeft: -1}}
                        onClick={() => setOpenSettingsDialog(true)}><SettingsIcon fontSize={'small'}/></IconButton>
          ) : null}
        </Typography>
        {renderWarning()}
      </Grid>

      {showSettings ? (
        <FermentationTimingSettingsControl pctName={fermPctName} pctLabel={fermPctLabel} pctValue={fermPctValue} pctValueArr={fermPctValueArr}
                                  tempName={fermTempName} tempLabel={fermTempLabel} tempValue={fermTempValue} tempValueArr={fermTempValueArr}
                                  change={onChange} stateLabel={fermStateLabel} />
      ) : null}
      <FermentationTimingSettingsDialog open={openSettingsDialog} close={() => setOpenSettingsDialog(false)} pctName={fermPctName} pctLabel={fermPctLabel} pctValue={fermPctValue} pctValueArr={fermPctValueArr}
                                        tempName={fermTempName} tempLabel={fermTempLabel} tempValue={fermTempValue} tempValueArr={fermTempValueArr}
                                        change={onChange} stateLabel={fermStateLabel} />
    </div>
  )
}

export {FermentationTimingControl}
